import { API_BASE_URL } from '../config/api';

const ONBOARDING_TUTORIAL_ID = 'onboarding_video';
const DASHBOARD_ROUTE = '/frame-140';
const ESTATE_SELECTOR_ROUTE = '/estate-selector';
const ONBOARDING_ROUTE = '/frame-134';

export interface PostLoginRoute {
  path: string;
  state?: {
    redirectTo: string;
  };
}

export const getAuthToken = (): string | null => {
  return localStorage.getItem('account-token');
};

const resolveDefaultDestination = async (accountToken: string): Promise<string> => {
  try {
    const rolesResponse = await fetch(`${API_BASE_URL}/api/user/roles`, {
      headers: { Authorization: `Bearer ${accountToken}` }
    });

    const rolesData = await rolesResponse.json();
    const hasExecutorRole =
      (Array.isArray(rolesData.executorFor) && rolesData.executorFor.length > 0) ||
      rolesData.isExecutor === true ||
      (Array.isArray(rolesData.roles) && rolesData.roles.includes('Executor for Someone Else'));
    const hasBeneficiaryRole =
      (Array.isArray(rolesData.beneficiaryFor) && rolesData.beneficiaryFor.length > 0) ||
      rolesData.isBeneficiary === true ||
      (Array.isArray(rolesData.roles) && rolesData.roles.includes('Beneficiary'));

    return rolesData.success && (hasExecutorRole || hasBeneficiaryRole)
      ? ESTATE_SELECTOR_ROUTE
      : DASHBOARD_ROUTE;
  } catch (rolesError) {
    console.error('Error checking executor status:', rolesError);
    return DASHBOARD_ROUTE;
  }
};

export const resolvePostLoginRoute = async (accountToken: string): Promise<PostLoginRoute> => {
  const redirectTo = await resolveDefaultDestination(accountToken);

  // Multi-role users (executor/beneficiary) should always land on estate selector first.
  // Onboarding is checked when they click "My Estate Plan" from estate selector.
  if (redirectTo === ESTATE_SELECTOR_ROUTE) {
    return { path: ESTATE_SELECTOR_ROUTE };
  }

  try {
    const tutorialResponse = await fetch(`${API_BASE_URL}/api/user/tutorial-status/${ONBOARDING_TUTORIAL_ID}`, {
      headers: { Authorization: `Bearer ${accountToken}` }
    });

    if (tutorialResponse.ok) {
      const tutorialData = await tutorialResponse.json();

      if (!tutorialData.dismissed) {
        return {
          path: ONBOARDING_ROUTE,
          state: { redirectTo }
        };
      }
    }
  } catch (tutorialError) {
    console.error('Error checking onboarding tutorial status:', tutorialError);
  }

  return { path: redirectTo };
};
